export default {
    "labels": {
        "labels": "Etiketten",
        "publicLabels": "Öffentliche Etiketten",
        "privateLabels": "Private Etiketten",
        "public": "Öffentliche",
        "private": "Private",
        "selectLabel": "Etikett(en) auswählen",
        "deleteLabelAreYouSure": "Möchten Sie dieses Etikett wirklich löschen: {name}?",
        "bulkAddLabelAreYouSure": "Möchten Sie wirklich das Etikett {name} zu allen Ergebnissen der aktuellen Suche hinzufügen?",
        "bulkRemoveLabelAreYouSure": "Möchten Sie wirklich das Etikett {name} von allen Ergebnissen der aktuellen Suche entfernen?",
        "addPublicLabelText": "+",
        "removePublicLabelText": "×",
        "addPublicLabelTitle": "Öffentliches Etikett hinzufügen",
        "selectPublicLabelTitle": "Öffentliches Etikett auswählen",
        "removePublicLabelTitle": "Öffentliches Etikett entfernen",
        "addPrivateLabelText": "+",
        "removePrivateLabelText": "×",
        "addPrivateLabelTitle": "Privates Etikett hinzufügen",
        "selectPrivateLabelTitle": "Privates Etikett auswählen",
        "removePrivateLabelTitle": "Privates Etikett entfernen"
    },

    "renameLabel": {
        "title": "Etikett(en) unbenennen",
        "btnRename": "Umbennen",
        "newLabel": "Neuen Etikett",
        "oldLabels": "Altes Etikett(en)",
        "alertText": "Diese Aktion benennt das (die) ausgewählte(n) Etikett(en) im Index um und ist unwiderruflich",
        "successFeedback": "Etikett(en), das (die) im Index umbenannt wurde(n)",
        "errorFeedback": "Ein Fehler ist aufgetreten. Die Suchanfrage war erfolglos"
    },

    "deleteLabel": {
        "title": "Etikett(en) global entfernen",
        "btnDelete": "Löschen",
        "alertText": "Diese Aktion löscht das (die) ausgewählte(n) Etikett(en) aus dem Index und ist unwiderruflich",
        "successFeedback": "Etikett(en), das (die) aus dem Index gelöscht wurde(n)",
        "errorFeedback": "Ein Fehler ist aufgetreten. Die Suchanfrage war erfolglos"
    },

    "bulkRemoveLabel": {
        "title": "Etikett(en) von aktuellen Ergebnissen entfernen",
        "btnBulkRemove": "Entfernen",
        "alertText": "Diese Aktion löscht das (die) ausgewählte(n) Etikett(en) aus allen gefundenen Ergebnisse (nicht nur die der ersten Seite)",
        "successFeedback": "Etikett(en), das (die) aus allen gefundenen Ergebnissen gelöscht wurde(n)",
        "errorFeedback": "Ein Fehler ist aufgetreten. Die Suchanfrage war erfolglos"
    },

    "bulkAddLabel": {
        "title": "Etikett(en) zu aktuellen Ergebnissen hinzufügen",
        "btnBulkAdd": "Hinzufügen",
        "alertText": "Diese Aktion fügt das (die) ausgewählte(n) Etikett(en) zu allen gefundenen Ergebnissen (nicht nur denen der ersten Seite) hinzu",
        "infoText": "klicken Sie auf 'Enter', um ein neues Etikett, das nicht in den Vorschlägen existiert, hinzuzufügen",
        "successFeedback": "Etikett(en), das (die) allen gefundenen Ergebnissen hinzugefügt wurde(n)",
        "errorFeedback": "Ein Fehler ist aufgetreten. Die Suchanfrage war erfolglos"
    },

    "editLabel": {
        "title": "Bearbeiten des (der) Etikett(en) aus dem (den) ausgewählten Ergebnis(sen)",
        "btnEdit": "speichern",
        "alertText": "Diese Aktion bearbeitet das (die) Etikett(en) des (der) ausgewählten Ergebnisse(s)",
        "infoText": "klicken Sie auf 'Enter', um ein neues Etikett, das nicht in den Vorschlägen existiert, hinzuzufügen",
        "labelsToBeRemoved": "Zu löschende(s) Etikett(en)",
        "labelsToBeAdded": "Hinzuzufügende(s) Etikett(en)",
        "successFeedback": "Etikett(en), das (die) zu dem (den) ausgewählten Ergebnis(sen) bearbeit(en)",
        "errorFeedback": "Ein Fehler ist aufgetreten. Die Suchanfrage war erfolglos"
    }
};
